<script setup>
import { computed } from 'vue';
import { BarChart } from '@chatwoot/viz';
import { buildCategoricalBarChartData } from './vizChartData';

const props = defineProps({
  labels: Array,
  values: Array,
  colors: Array,
  percents: Array,
  title: String,
});

const chartData = computed(() =>
  buildCategoricalBarChartData(props.labels, props.values, props.colors)
);

const pointDescription = (_, index) => `${props.percents[index]}%`;
</script>

<template>
  <div>
    <h3 class="font-semibold text-base mb-2">{{ title }}</h3>
    <BarChart
      :data="chartData"
      :aria-label="title"
      :height="180"
      :bar-radius="8"
      :max-bar-width="32"
      :point-description="pointDescription"
      class="w-full"
    />
  </div>
</template>
